import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth, postJson } from "@/lib/auth";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setMember } = useAuth();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    postJson("/members/google/session", { session_id: sessionId })
      .then((m) => { setMember(m); navigate("/perfil", { replace: true, state: { member: m } }); })
      .catch(() => { setMember(false); navigate("/entrar?error=google", { replace: true }); });
  }, [location.hash, navigate, setMember]);
  return <main className="min-h-screen" data-testid="auth-callback" />;
};
